const steps = [
  {
    number: "01",
    icon: "ri-chat-3-line",
    title: "Krótka rozmowa (15 min)",
    desc: "Opowiedz o swojej firmie — branża, miasto, czego potrzebujesz. Bez zobowiązań, bez formalności.",
    accent: "#1D4ED8",
    bg: "#EFF6FF",
  },
  {
    number: "02",
    icon: "ri-code-s-slash-line",
    title: "Tworzenie strony (3–5 dni)",
    desc: "Projektuję i wdrażam stronę dopasowaną do Twojej branży — z formularzami, CTA i lokalnym SEO.",
    accent: "#059669",
    bg: "#ECFDF5",
  },
  {
    number: "03",
    icon: "ri-phone-line",
    title: "Publikacja i pierwsze zapytania",
    desc: "Strona jest online. Klienci zaczynają Cię znajdować w Google i się kontaktować.",
    accent: "#D97706",
    bg: "#FFFBEB",
  },
];

const HowItWorksSection = () => {
  return (
    <section id="jak-to-dziala" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-[#1D4ED8] text-sm font-semibold tracking-wide uppercase mb-3">
            Jak wygląda współpraca
          </span>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-[#0F172A] mb-5 leading-tight">
            Proste. Szybkie. Konkretne.
          </h2>
          <p className="text-[#64748B] text-lg leading-relaxed">
            Od pierwszej rozmowy do gotowej strony generującej zapytania — w kilka dni.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 lg:gap-8 relative">
          <div className="hidden lg:block absolute top-12 left-[calc(16.66%+2rem)] right-[calc(16.66%+2rem)] h-0.5 bg-gradient-to-r from-[#1D4ED8]/30 via-[#059669]/30 to-[#D97706]/30"></div>

          {steps.map((step, i) => (
            <div key={step.number} className="relative flex flex-col items-center text-center gap-5 bg-[#F8FAFF] rounded-2xl border border-gray-100 p-8">
              <div className="relative z-10">
                <div
                  className="w-16 h-16 flex items-center justify-center rounded-full border-2"
                  style={{ backgroundColor: step.bg, borderColor: `${step.accent}30` }}
                >
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${step.icon} text-2xl`} style={{ color: step.accent }}></i>
                  </div>
                </div>
                <span
                  className="absolute -top-2 -right-2 w-6 h-6 rounded-full text-white text-xs font-bold flex items-center justify-center"
                  style={{ backgroundColor: step.accent }}
                >
                  {i + 1}
                </span>
              </div>
              <div>
                <h3 className="font-bold text-[#0F172A] text-lg mb-2">{step.title}</h3>
                <p className="text-[#64748B] text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
